import {
  HighlightOffTwoTone,
  MemoryTwoTone,
  MoreVertTwoTone,
  SearchTwoTone,
  SettingsRemoteTwoTone,
} from '@mui/icons-material'
import { Avatar, Divider, IconButton, List, Tooltip } from '@mui/material'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { VirtualSensorPool } from '@/types/domain/virtualsensor'

import {
  getStorage,
  isFilterMatch,
  setStorage,
  SORT_ATTR_NAME,
} from '../../api'
import {
  AM,
  AMItem,
  KPage,
  KTextField,
  VirtualSensorItem,
} from '../../components'
import { useVirtualSensorPool } from '../../hooks'

type Props = {
  PAGE_CONFIG?: string
}

export const AllVSensors = ({
  PAGE_CONFIG = 'settings_virtual_sensors_all',
}: Props) => {
  const navigate = useNavigate()
  const data: VirtualSensorPool = useVirtualSensorPool()

  const [badge, setBadge] = useState<string>('laden')
  const [config, setConfig] = useState(getStorage(PAGE_CONFIG))
  const [actionMenu, setActionMenu] = useState(null)

  const inputFilter = vSensor =>
    config.filter
      ? isFilterMatch(config.filter, vSensor.attributes.name) ||
        isFilterMatch(
          config.filter,
          vSensor.attributes.combined_virtual_sensor_id
        ) ||
        isFilterMatch(
          config.filter,
          vSensor.attributes.combined_virtual_sensor_device_id
        ) ||
        isFilterMatch(config.filter, vSensor.attributes.original_sensors_id) ||
        isFilterMatch(config.filter, vSensor.attributes.virtual_sensor_type) ||
        Number(config.filter) === Number(vSensor.id)
      : vSensor

  useEffect(() => setStorage(PAGE_CONFIG, config), [PAGE_CONFIG, config])

  useEffect(
    () => setBadge(data.length === 0 ? 'laden' : String(data.length)),
    [data, data.length]
  )

  return (
    <>
      {/* action menu */}
      <AM
        anchorEl={actionMenu}
        caption={'Sensoren'}
        onClose={() => setActionMenu(null)}
        open={Boolean(actionMenu)}
        historyUrlTarget={'sensors'}
      >
        <AMItem
          caption={'Neu'}
          icon={<MemoryTwoTone />}
          onClick={() => navigate('/virtualsensors/new')}
        />

        <Divider />
      </AM>
      {/* action menu end */}

      {data.length > 0 && (
        <KPage
          action={
            <IconButton onClick={event => setActionMenu(event.currentTarget)}>
              <MoreVertTwoTone />
            </IconButton>
          }
          avatar={
            <Avatar>
              <SettingsRemoteTwoTone />
            </Avatar>
          }
          title={`${badge} virtuelle Sensoren`}
          subheader={
            config?.filter?.length > 0 &&
            `${data.filter(inputFilter).length} Treffer`
          }
        >
          {/* filter */}
          <KTextField
            icon={<SearchTwoTone />}
            onChange={event => {
              const filter = event.target.value

              setConfig(prev => ({ ...prev, filter }))
            }}
            sx={{ mb: 5 }}
            unit={
              config?.filter?.length > 0 && (
                <Tooltip title={'Filter löschen'}>
                  <IconButton
                    onClick={() => setConfig(prev => ({ ...prev, filter: '' }))}
                  >
                    <HighlightOffTwoTone />
                  </IconButton>
                </Tooltip>
              )
            }
            value={config.filter}
          />

          <List
            sx={{
              maxHeight: 600,
              mt: 3,
              overflow: 'auto',
              overflowX: 'hidden',
              width: 1,
            }}
          >
            {data
              .filter(inputFilter)
              .sort(SORT_ATTR_NAME)
              .map(s => (
                <VirtualSensorItem
                  key={s.id}
                  sensor={s}
                  sensorId={Number(s.id)}
                />
              ))}
          </List>
        </KPage>
      )}
    </>
  )
}
